<template>
  <div class="track-customer">
    <template v-if="list.length">
      <div class="list-items">
        <RenderItem v-for="item in list" :key="item.id" :dataItem="item">
          <template v-slot:footer>
            <van-button size="small" :to="{ name: 'CustomerDetails', query: { id: item.id } }">查看详情</van-button>
          </template>
        </RenderItem>
      </div>
    </template>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import RenderItem from '../customer/components/renderItem'
import { getCustomerList } from '@/api/customer'
export default {
  name: 'TrackCustomer',
  components: { RenderItem },
  data() {
    return {
      list: []
    }
  },
  computed: {
    time() {
      const { date } = this.$route.query
      return {
        startTime: dayjs(date).startOf('day').unix(),
        endTime: dayjs(date).endOf('day').unix()
      }
    }
  },
  created() {
    this.getCustomerList()
  },
  methods: {
    getCustomerList() {
      getCustomerList({ page: 1, count: 2000, ...this.time }).then((res) => {
        if (res.errcode === 0) {
          this.list = res.data
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .track-customer {
    .list-items { padding-bottom: 10px;
      .footer { padding: 0; margin-top: 5px;
        .van-button { width: 100%; text-align: center; border: none; height: 40px;
          &__content { justify-content: center; color: #169BD5; }
        }
      }
    }
  }
</style>